'use client';

import { useEffect, useState } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import { useReducedMotionPref } from '@/lib/motion';

export function ScrollProgress() {
  const [isVisible, setIsVisible] = useState(false);
  const shouldReduceMotion = useReducedMotionPref();
  
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 120);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (shouldReduceMotion) {
    return null;
  }

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 z-50 hidden sm:block"
      initial={{ opacity: 0 }}
      animate={{ opacity: isVisible ? 1 : 0 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        className="mx-auto h-1.5 max-w-6xl bg-amber-100/80 rounded-full backdrop-blur-sm overflow-hidden"
        style={{ scaleX }}
      >
        <motion.div 
          className="absolute inset-0 bg-gradient-to-r from-amber-500 via-orange-500 to-amber-600 origin-left"
          animate={{
            x: ['-100%', '100%'],
          }}
          transition={{
            duration: 1.6,
            repeat: Infinity,
            ease: 'linear',
          }}
        />
      </motion.div>
    </motion.div>
  );
}
